// The subset of a selected profile needed to decide Instagram location
// tagging. Kept structural (rather than importing the legacy `ComposerProfile`)
// so this predicate carries no legacy dependency and legacy call sites import
// down into it, not the reverse.
type LocationTaggingProfile = {
  apiVersion?: string | null
  serviceType: string
}

// Instagram location tagging is only available for business/creator accounts on
// the Graph API path: Instagram-Login connections and personal profiles cannot
// tag a location. Shared by the location picker (which hides itself), the
// reminder field filter (which drops the location fields), and the GraphQL save
// path (which drops the geolocation fields) so the three can't drift and leak a
// location to a channel that would reject it.
export function supportsInstagramLocationTagging(
  profile: LocationTaggingProfile,
): boolean {
  return (
    profile.apiVersion !== 'instagramLogin' && profile.serviceType !== 'profile'
  )
}
